var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner"},[_c('p',[_vm._v("Multiple frames selection options "),_c('br'),_vm._v("not available yet")])])
}]

export { render, staticRenderFns }